import {createApi,fetchBaseQuery,BaseQueryFn} from '@reduxjs/toolkit/query/react';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import {Sep24DepositWithdrawParams, Sep24DepositWithDrawResponse,Sep24TransactionResponseItem,Sep24TransactionsParams,Sep24TransactionsResponse } from '../../../types/stellarseps';
import {stellarTolmResolver} from "../../stellar/tolm";

const getSep24Transactions = async(params:Sep24TransactionsParams):Promise<[any,Sep24TransactionResponseItem[]]>=>{

    let responseError:any;
    let responseTransactions:Sep24TransactionResponseItem[] = []

    const [err,toml] = await stellarTolmResolver(params.domain);

    if (err){

        const error = err as Error

        responseError = error
    }

    if (toml){

        const url = toml.TRANSFER_SERVER_SEP0024;

        if (!url){

            responseError = new Error('TRANSFER_SERVER_SEP0024 not available')

        }

        try {

            const axiosConfig: AxiosRequestConfig = {
                method: "get",
                url: `${url}/transactions`,
                params: {
                    asset_code:params.asset_code,
                    limit:params.limit || 10,
                    paging_id:params.paging_id 
                },
                headers: {'Authorization': 'Bearer '+params.token}
            };

            const axiosResponse = await axios.request(axiosConfig);

            responseTransactions = axiosResponse.data.transactions;

        } catch (axiosError) {

            const err = axiosError as AxiosError;

            responseError = new Error(JSON.stringify(err.response?.data))
        }
    }

    return [responseError,responseTransactions]

}

export const depositWithdrawApi = createApi({
    reducerPath:"depositWithdrawApi ",
    baseQuery: fetchBaseQuery({ baseUrl: '/ ' }),
    tagTypes: ['Sep24Transactions'],
    endpoints: (builder) => ({
        sep24Deposit: builder.query<Sep24DepositWithDrawResponse, Sep24DepositWithdrawParams>({
            
            async queryFn(_arg,queryApi, extraOptions, baseQuery) {

                let resultData:Sep24DepositWithDrawResponse = {
                    type:'',
                    url:'',
                    id:'',
                }
                
                const [err,toml] = await stellarTolmResolver(_arg.domain);

                if (err){

                    return { error: err };
                }

                const url = toml.TRANSFER_SERVER_SEP0024;

                if (url){

                    try {

                        const axiosConfig: AxiosRequestConfig = {
                            method: "post",
                            url: `${url}/transactions/deposit/interactive`,
                            data: {
                                asset_code:_arg.asset_code,
                                asset_issuer:_arg.asset_issuer,
                                amount:_arg.amount,
                                account:_arg.account,
                                memo_type:_arg.memo_type,
                                memo:_arg.memo,
                                claimable_balance_supported:_arg.claimable_balance_supported,
                                email_address:_arg.email_address,
                                mobile_number:_arg.mobile_number
                                

                                
                            },
                            headers: {'Authorization': 'Bearer '+_arg.token}
                        };

                        const axiosResponse = await axios.request(axiosConfig);

                        resultData = axiosResponse.data
                        
                    } catch (axiosError) {

                        const err = axiosError as AxiosError;
                        return { error: { status: err.response?.status, data: err.response?.data } }; 
                  
                    }
                }

                return {data: resultData}
            },

        }),
        sep24Withdraw: builder.query<Sep24DepositWithDrawResponse, Sep24DepositWithdrawParams>({
            
            async queryFn(_arg,queryApi, extraOptions, baseQuery) {

                let resultData:Sep24DepositWithDrawResponse = {
                    type:'',
                    url:'',
                    id:'',
                }
                
                const [err,toml] = await stellarTolmResolver(_arg.domain);

                if (err){

                    return { error: err };
                }

                const url = toml.TRANSFER_SERVER_SEP0024;

                if (url){

                    try {

                        const axiosConfig: AxiosRequestConfig = {
                            method: "post",
                            url: `${url}/transactions/withdraw/interactive`,
                            data: {
                                asset_code:_arg.asset_code,
                                asset_issuer:_arg.asset_issuer,
                                amount:_arg.amount,
                                account:_arg.account,
                                memo_type:_arg.memo_type,
                                memo:_arg.memo,
                                email_address:_arg.email_address,
                                mobile_number:_arg.mobile_number
                            },
                            headers: {'Authorization': 'Bearer '+_arg.token}
                        };

                        const axiosResponse = await axios.request(axiosConfig);

                        resultData = axiosResponse.data
                       

                        
                    } catch (axiosError) {
                        

                        const err = axiosError as AxiosError;
                        return { error: { status: err.response?.status, data: err.response?.data } }; 
                  
                    }
                }

                return {data: resultData}
            },
        }),
       
        sep24Transactions: builder.query<Sep24TransactionResponseItem[], Sep24TransactionsParams>({   
            
            async queryFn(_arg,queryApi, extraOptions, baseQuery){

                const [error,response] = await getSep24Transactions(_arg);
                
                return {data: response}     
            },
           
            providesTags: ['Sep24Transactions'],
            

        }),
 
    })
})

export const {useSep24DepositQuery,useSep24WithdrawQuery,useSep24TransactionsQuery} = depositWithdrawApi

         
